import { render, staticRenderFns } from "./CreateRecipesModal.vue?vue&type=template&id=03dfada8&scoped=true&lang=pug"
import script from "./CreateRecipesModal.vue?vue&type=script&lang=js"
export * from "./CreateRecipesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateRecipesModal.vue?vue&type=style&index=0&id=03dfada8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfada8",
  null
  
)

export default component.exports